module.exports = __webpack_public_path__ + "img/orbpay.8dfc0b73.svg";